import axios from 'util/axios';
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useOktaAuth } from '@okta/okta-react';
import { Cookies } from "react-cookie";
const cookies = new Cookies();

const Logout = () => {
    const dispatch = useDispatch();
    const { oktaAuth } = useOktaAuth();
    useEffect(() => {
        _logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const _logout = async() => {
        dispatch({type: "LOGOUT"});
        cookies.remove("bpl_login");
        try {
            await axios.post(process.env.REACT_APP_API+"/user/logout")
            await oktaAuth.session.refresh()

            await oktaAuth.signOut();
        } catch(e) {
            window.location.replace("/");
        }
    }
    return (<div>Logging out</div>)
}

export default Logout;